<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
    <path fill="currentColor" d="M1.75858 18L0.333252 16.5747L7.90793 9L0.333252 1.42532L1.75858 0L9.33325 7.57468L16.9079 0L18.3333 1.42532L10.7586 9L18.3333 16.5747L16.9079 18L9.33325 10.4253L1.75858 18Z" />
  </svg>
</template>